// Imports (unchanged)
import { Wrapper } from "../../styles/AddBookStyle";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ageGroupSelected,
  onAuthorEntered,
  onParagraphChanged,
  onTitleEntered,
  onBookLevelSelected
} from "../../../slices/books/addBookSlice";
import { FormRow } from "../../../components";
import { FileUploader } from "react-drag-drop-files";
import AlertDialog from "../../../components/AlertDialog";
import errorHandler from "../../../utils/errorHandler";
import { useLocation, useParams } from "react-router-dom";
import { getBookById } from "../../../controller/bookSelection/bookSelectionController";

const PreviewSelectedOwnBook = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [coverImage, setCoverImage] = useState(null);
  const [createNewForm, setCreateNewForm] = useState(false);
  const [updateBook, setUpdateBook] = useState(false);

  const {
    isLoading,
    title,
    author,
    paragraph,
    paragraphs,
    level
  } = useSelector((store) => store.addBooks);
  const { selectedBook } = useSelector((store) => store.bookSelection);
  const dispatch = useDispatch();
  const { bookId } = useParams();
  const { state } = useLocation();
  const { OS } = state || {};
  const shouldSkipFetch = Boolean(state?.skipFetch);


  const fileTypes = ["JPG", "PNG", "GIF"];

  useEffect(() => {
    if (bookId && !shouldSkipFetch) dispatch(getBookById(bookId));
  }, [bookId, dispatch, shouldSkipFetch]);

  useEffect(() => {
    if (selectedBook?.title && selectedBook?.authors?.length > 0) {
      dispatch(onTitleEntered(selectedBook.title));
      dispatch(onAuthorEntered(selectedBook.authors[0].name));
      if (selectedBook.formats?.["image/jpeg"]) {
        setCoverImage(selectedBook.formats["image/jpeg"]);
      }
       if (selectedBook.paragraphText) {
        dispatch(onParagraphChanged(selectedBook.paragraphText.trim()));
      }
      if (!level) {
        dispatch(onBookLevelSelected('A'));
    }
    }
  }, [selectedBook, dispatch]);

  const onBookCoverAttached = (file) => setCoverImage(file);


  const onTitleChanged = (e) => dispatch(onTitleEntered(e.target.value));
  const onAuthorChanged = (e) => dispatch(onAuthorEntered(e.target.value));
  const onParagraphDataChannge = (e) => dispatch(onParagraphChanged(e.target.value));

  const onCreateNewBook = (e) => {
    e.preventDefault();
    if (isFormValidated()) {
      setCreateNewForm(true);
      setOpenDialog(true);
    }
  };


  const isFormValidated = () => {
   if (!title || !author || !paragraph) {
        errorHandler("Required fields are missing!");
        return false;
      }
      return true
  };

  const onCloseDialog = () => setOpenDialog(false);

  const runTaskAndCloseDialog = () => {
    const bookObj = getBookObj();
   
    console.log(`BookBoj: ${JSON.stringify(bookObj)}`);
    handleBookSelected(bookObj)
    onCloseDialog();
    setCreateNewForm(false);
    setUpdateBook(false);
  };

  const handleBookSelected = (payload) => {
  if (OS === "iOS") {
    try {
      window.webkit?.messageHandlers?.ReadRivalsJS?.onBookSelected?.postMessage(payload);
    } catch (error) {
      console.log(`Error sending iOS JavaScript callback: ${error}`);
    }
  } else if (OS === "Android") {
    if (window.ReadRivalsJS !== undefined) {
      try {
        window.ReadRivalsJS?.onBookSelected(JSON.stringify(payload));
      } catch (error) {
        console.log(`Error sending Android JavaScript callback: ${error}`);
      }
    }
  } else {
    console.warn("Unknown platform. Book selection callback not sent.");
  }
};

const getBookObj = () => {
  const splitParagraphs = (paragraphText) => {
  if (!paragraphText || paragraphText.trim().length < 1000) {
    return paragraphText.trim()
      ? [{ paragraph: paragraphText.trim() }]
      : [];
  }

  const cleaned = paragraphText.replace(/\s+/g, ' ').trim();
  const sentences = cleaned.match(/[^.!?]+[.!?]+["')\]]*\s*/g) || [];

  const result = [];
  let buffer = "";

  for (const sentence of sentences) {
    const temp = buffer + sentence;

    if (temp.trim().length < 1000) {
      buffer = temp;
    } else {
      if (buffer.trim().length > 0) {
        result.push({ paragraph: buffer.trim() });
      }
      buffer = sentence;
    }
  }

  if (buffer.trim().length > 0) {
    result.push({ paragraph: buffer.trim() });
  }

  return result;
};
  const cleanParagraphs =
    selectedBook?.paragraphText?.trim()?.length > 0
      ? splitParagraphs(selectedBook.paragraphText)
      : paragraphs.filter((p) => p.paragraph && p.paragraph.trim() !== '');

  return {
    book: {
      title,
      image: coverImage,
      author,
      level:level,
      paragraphs: cleanParagraphs
    }
  };
};

  const renderUploaderOrImage = () => {
    if (coverImage && typeof coverImage === 'string') {
      return <img src={coverImage} alt="Book Cover" style={{ width: '180px', marginTop: '2rem', borderRadius: '8px' }} />
    }
    return (
      <div style={{ marginTop: "2rem" }}>
        <FileUploader
          label="Upload a picture of book cover"
          name="file"
          types={fileTypes}
          handleChange={onBookCoverAttached}
        />
      </div>
    );
  };


  return (
    <Wrapper>
      <form className="form">
        <h3>Preview book</h3>

        <div className="sub-form-items">
          <FormRow type="text" name="Title" placeholder="Enter Title" required value={title} handleChange={onTitleChanged} />
          <FormRow type="text" name="Author" placeholder="Enter author's name" required value={author} handleChange={onAuthorChanged} />
        </div>

        {renderUploaderOrImage()}

        <div className="text-area-container">
          <textarea
            className="text-area"
            placeholder="Enter paragraph here..."
            value={paragraph}
            readOnly
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onChange={onParagraphDataChannge}
          />
        </div>

        <div className="form-center" style={{ marginTop: "1rem" }}>
          <button style={{ width: "100%"}} className="btn btn-block" onClick={onCreateNewBook} disabled={isLoading}>{isLoading ? "Please Wait" : "Submit"}</button>
        </div>
      </form>

      {openDialog && (
        <AlertDialog
          open={openDialog}
          onClose={onCloseDialog}
          runTaskAndClose={runTaskAndCloseDialog}
          title={(createNewForm || updateBook) ? "Ready to submit?" : "Are you sure?"}
          description={(createNewForm || updateBook)
            ? "Request to save this book to server will be processed"
            : "All the progress will be deleted permanently from this machine."}
          agreeText={(createNewForm || updateBook) ? "Submit" : "Delete"}
          disagreeText={(createNewForm || updateBook) ? "Not Yet!" : "Cancel"}
        />
      )}
    </Wrapper>
  );
};

export default PreviewSelectedOwnBook;